import first from "lodash/first";
import { fetchQuery, graphql } from "react-relay";
import type RelayModernEnvironment from "relay-runtime/lib/store/RelayModernEnvironment";

import type {
  helpersRosettaPaywallArticleSearchQuery,
  helpersRosettaPaywallArticleSearchQuery$variables,
} from "scmp-app/queries/__generated__/helpersRosettaPaywallArticleSearchQuery.graphql";

import { PaywallMeterModalClassName } from "./consts";

export const setPianoCustomVariable = (key: string, value: unknown) => {
  window.tp ??= [];
  setPianoVariable("setCustomVariable", key, value);
};

export const setPianoVariable = (eventName: string, ...parameters: unknown[]) => {
  window.tp ??= [];
  window.tp.push([eventName, ...parameters]);
};

export const closeAndClearUpPianoMeterModal = () => {
  if (!window.tp || !document.body.classList.contains(PaywallMeterModalClassName)) return;
  window.tp.offer?.close?.();
  document.body.classList.remove(PaywallMeterModalClassName);
};

export const searchArticles = async ({
  environment,
  filter,
}: {
  environment: RelayModernEnvironment;
  filter: {
    sectionIds?: string[];
    size?: number;
  };
}) => {
  const variables: helpersRosettaPaywallArticleSearchQuery$variables = {
    first: filter?.size ?? 10,
    sectionIds: filter?.sectionIds ?? [],
  };

  const sectionArticlesData = await fetchQuery<helpersRosettaPaywallArticleSearchQuery>(
    environment,
    relatedSectionQuery,
    variables,
  ).toPromise();

  const articles =
    sectionArticlesData?.articles?.edges?.map(edge => ({
      entityId: edge.node.entityId,
      headline: edge.node.headline,
      imageUrl: first(edge?.node?.images)?.url,
    })) ?? [];

  return {
    articles,
  };
};

const relatedSectionQuery = graphql`
  query helpersRosettaPaywallArticleSearchQuery($first: Int!, $sectionIds: [String]) {
    articles(
      first: $first
      filter: { sectionIds: $sectionIds }
      orderBy: { field: PUBLISHED_DATE, direction: DESC }
    ) {
      edges {
        node {
          entityId
          headline
          images {
            url
          }
        }
      }
    }
  }
`;
